import React from "react"

import DocumentType from "components/Tvendo/BusinessPartner/DataMaster/DocumentType/List.js"

export default function (){
  return (
    <DocumentType></DocumentType>
  )
}